export default __webpack_public_path__ + "static/media/11-51.432fbdad.png";